import { SVGProps } from "react";

const Regenerate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_20693_9871)">
      <path
        d="M21.0174 10.8726C20.7418 8.88923 19.8217 7.05148 18.3988 5.64247C16.976 4.23345 15.1294 3.33133 13.1434 3.07507C11.1574 2.81882 9.14224 3.22264 7.40834 4.22434C5.67443 5.22603 4.31797 6.77003 3.54791 8.61849M2.98438 4.11023V8.61849H7.49264"
        stroke="url(#paint0_linear_20693_9871)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.98438 13.127C3.26001 15.1103 4.18011 16.9481 5.60296 18.3571C7.0258 19.7661 8.87244 20.6682 10.8584 20.9245C12.8444 21.1808 14.8596 20.7769 16.5935 19.7752C18.3274 18.7735 19.6838 17.2295 20.4539 15.3811M21.0174 19.8893V15.3811H16.5092"
        stroke="url(#paint1_linear_20693_9871)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.5C12 8.5 12.6044 10.1278 13.3635 10.8869C14.1225 11.6458 15.75 12.25 15.75 12.25C15.75 12.25 14.1225 12.8549 13.3635 13.614C12.6047 14.3729 12 16 12 16C12 16 11.3953 14.3729 10.6365 13.614C9.87746 12.8549 8.25 12.25 8.25 12.25C8.25 12.25 9.87748 11.6458 10.6365 10.8869C11.3956 10.1278 12 8.5 12 8.5Z"
        fill="url(#paint2_linear_20693_9871)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_20693_9871"
        x1={1.48093}
        y1={5.84277}
        x2={16.2072}
        y2={18.586}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#003890" />
        <stop offset={1} stopColor="#E43820" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_20693_9871"
        x1={1.48093}
        y1={15.9697}
        x2={16.2072}
        y2={28.7129}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#003890" />
        <stop offset={1} stopColor="#E43820" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_20693_9871"
        x1={10.3332}
        y1={9.54147}
        x2={13.2494}
        y2={15.9986}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#003890" />
        <stop offset={1} stopColor="#E43820" />
      </linearGradient>
      <clipPath id="clip0_20693_9871">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Regenerate;
